export default __webpack_public_path__ + "static/media/no22.2bd319a7.png";